<div id="dept-physics" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Physics</h2>
    <p class="inner-lead mt-3">
      The Department of Physics at Shah Satnam Ji Girls' College, Sirsa is equipped with a well-maintained Physics laboratory. Students gain hands-on experience in practical experiments alongside theoretical knowledge, preparing them for careers in science and technology.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Physics as a subject in B.Sc. (Non-Medical)</li>
      <li>Physics as a subject in B.Sc. (Computer Science)</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Dr. Rekha Mehta</td><td>Ph.D</td></tr>
          <tr><td>2</td><td>Ms. Bhavya</td><td>M.Sc., B.Ed., Ph.D (Pursuing)</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>Science Quiz Competition</li>
      <li>Essay Writing Competition</li>
      <li>Field Visit (Outdoor)</li>
    </ul>

  </div>
</div>
